var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.companyItemTypes
    ? _c("div", [
        _c(
          "table",
          {
            staticClass: "table is-bordered is-narrow is-fullwidth",
            class: { "is-loading": _vm.isFetchingSupplementaryQuote },
          },
          [
            _c("thead", [
              _c(
                "tr",
                {
                  staticClass: "no-border",
                  class: `summary-background-text-${_vm.$theme.name}`,
                },
                [
                  _c("th", [_vm._v("Category")]),
                  _vm.value.subQuoteNos.length > 1 && _vm.value.subQuoteNo === 0
                    ? [
                        _vm._l(_vm.value.subQuoteNos, function (sub) {
                          return _c(
                            "th",
                            {
                              key: sub.value,
                              staticClass: "has-text-right is-subtotal",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    sub.key === 0 ? "Main" : `Add-${sub.key}`
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        }),
                        _c(
                          "th",
                          { staticClass: "has-text-right is-subtotal" },
                          [_vm._v(" Summary ")]
                        ),
                      ]
                    : _vm.value.subQuoteNos.length === 1 ||
                      _vm.value.subQuoteNo > 0
                    ? [
                        _c(
                          "th",
                          { staticClass: "has-text-right is-subtotal" },
                          [_vm._v(" Total ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm.value.subQuoteNos.length === 1 ||
            _vm.showSupplementaryQuoteTotals ||
            _vm.value.subQuoteNo > 0
              ? _c("tfoot", { staticClass: "no-border" }, [
                  _c(
                    "tr",
                    {
                      staticClass: "has-border-bottom-4",
                      class: [`summary-background-text-${_vm.$theme.name}`],
                    },
                    [
                      _vm._m(0),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.value.totalExGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _vm.showSupplementaryQuoteTotals
                        ? [
                            _vm._l(_vm.supplementaryQuotes, function (supp) {
                              return _c(
                                "td",
                                {
                                  key: supp.quoteId,
                                  staticClass: "has-text-right",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          supp.totalExGst,
                                          _vm.$userInfo.locale
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.calculateGrandTotal(
                                      _vm.value.totalExGst,
                                      _vm.supplementaryQuotes.map(
                                        (q) => q.totalExGst
                                      )
                                    ),
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm.value.discount
                    ? _c(
                        "tr",
                        [
                          _c("td", [_vm._v("Discount")]),
                          _c(
                            "td",
                            { staticClass: "has-text-right has-text-danger" },
                            [
                              _vm._v(
                                "- " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.value.discount,
                                      _vm.$userInfo.locale
                                    )
                                  )
                              ),
                            ]
                          ),
                          _vm.showSupplementaryQuoteTotals
                            ? [
                                _vm._l(
                                  _vm.supplementaryQuotes,
                                  function (supp) {
                                    return _c(
                                      "td",
                                      {
                                        key: supp.quoteId,
                                        staticClass: "has-text-right",
                                      },
                                      [_vm._v("- ")]
                                    )
                                  }
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-right has-text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "- " +
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.value.discount,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.value.excess && _vm.value.excessWithGst
                    ? _c(
                        "tr",
                        [
                          _c("td", [_vm._v("Excess")]),
                          _c(
                            "td",
                            { staticClass: "has-text-right has-text-danger" },
                            [
                              _vm._v(
                                "- " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.value.excess,
                                      _vm.$userInfo.locale
                                    )
                                  )
                              ),
                            ]
                          ),
                          _vm.showSupplementaryQuoteTotals
                            ? [
                                _vm._l(
                                  _vm.supplementaryQuotes,
                                  function (supp) {
                                    return _c(
                                      "td",
                                      {
                                        key: supp.quoteId,
                                        staticClass: "has-text-right",
                                      },
                                      [_vm._v("- ")]
                                    )
                                  }
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-right has-text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "- " +
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.value.excess,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "tr",
                    {
                      staticClass: "has-border-bottom-4",
                      class: [`summary-background-primary-${_vm.$theme.name}`],
                    },
                    [
                      _c("td", [
                        _vm._v("GST "),
                        _c("span", { staticClass: "subtext" }, [
                          _vm._v("(" + _vm._s(_vm.value.gstRate) + "%)"),
                        ]),
                      ]),
                      _vm.showSupplementaryQuoteTotals
                        ? [
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm.mainQuoteTotalGst > 0
                                ? _c("span", [_vm._v("+")])
                                : _vm._e(),
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.mainQuoteTotalGst,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm._l(_vm.supplementaryQuotes, function (supp) {
                              return _c(
                                "td",
                                {
                                  key: supp.quoteId,
                                  staticClass: "has-text-right",
                                },
                                [
                                  _vm._v(
                                    " +" +
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          (supp.totalExGst * supp.gstRate) /
                                            100,
                                          _vm.$userInfo.locale
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                          ]
                        : _vm._e(),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm.invTotalExGst > 0
                          ? _c("span", [_vm._v("+")])
                          : _vm._e(),
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.invTotalExGst * (_vm.value.gstRate / 100),
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm.showInvAmtIncGst
                    ? _c(
                        "tr",
                        { class: `summary-background-text-${_vm.$theme.name}` },
                        [
                          _vm._m(1),
                          _vm.showSupplementaryQuoteTotals
                            ? [
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.mainQuoteTotalIncGst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _vm._l(
                                  _vm.supplementaryQuotes,
                                  function (supp) {
                                    return _c(
                                      "td",
                                      {
                                        key: supp.quoteId,
                                        staticClass: "has-text-right",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$filters.formatCurrency(
                                                supp.totalIncGst,
                                                _vm.$userInfo.locale
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ]
                            : _vm._e(),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.invTotalExGst *
                                    (_vm.value.gstRate / 100 + 1),
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.value.ownersContribution
                    ? _c(
                        "tr",
                        [
                          _vm._m(2),
                          _vm.showSupplementaryQuoteTotals
                            ? [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-right has-text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "- " +
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.value.ownersContribution *
                                              (_vm.value.gstRate / 100 + 1),
                                            _vm.$userInfo.locale
                                          )
                                        )
                                    ),
                                  ]
                                ),
                                _vm._l(
                                  _vm.supplementaryQuotes,
                                  function (supp) {
                                    return _c(
                                      "td",
                                      {
                                        key: supp.quoteId,
                                        staticClass: "has-text-right",
                                      },
                                      [_vm._v("- ")]
                                    )
                                  }
                                ),
                              ]
                            : _vm._e(),
                          _c(
                            "td",
                            { staticClass: "has-text-right has-text-danger" },
                            [
                              _vm._v(
                                "- " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.value.ownersContribution *
                                        (_vm.value.gstRate / 100 + 1),
                                      _vm.$userInfo.locale
                                    )
                                  )
                              ),
                            ]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.value.excess && !_vm.value.excessWithGst
                    ? _c(
                        "tr",
                        [
                          _c("td", [_vm._v("Excess")]),
                          _vm.showSupplementaryQuoteTotals
                            ? [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-right has-text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "- " +
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.value.excess,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                    ),
                                  ]
                                ),
                                _vm._l(
                                  _vm.supplementaryQuotes,
                                  function (supp) {
                                    return _c(
                                      "td",
                                      {
                                        key: supp.quoteId,
                                        staticClass: "has-text-right",
                                      },
                                      [_vm._v("- ")]
                                    )
                                  }
                                ),
                              ]
                            : _vm._e(),
                          _c(
                            "td",
                            { staticClass: "has-text-right has-text-danger" },
                            [
                              _vm._v(
                                "- " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.value.excess,
                                      _vm.$userInfo.locale
                                    )
                                  )
                              ),
                            ]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "tr",
                    { class: `summary-background-success-${_vm.$theme.name}` },
                    [
                      _vm._m(3),
                      _vm.showSupplementaryQuoteTotals
                        ? [
                            _c("th", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.mainQuoteTotalPayable,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm._l(_vm.supplementaryQuotes, function (supp) {
                              return _c(
                                "th",
                                {
                                  key: supp.quoteId,
                                  staticClass: "has-text-right",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          supp.totalIncGst,
                                          _vm.$userInfo.locale
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                          ]
                        : _vm._e(),
                      _c("th", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.totalPayableIncGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm.value.subQuoteNos.length === 1 ||
            _vm.showSupplementaryQuoteTotals ||
            _vm.value.subQuoteNo > 0
              ? _c(
                  "tbody",
                  { staticClass: "has-bottom-border-only no-border-last-row" },
                  [
                    _vm.isEnabled(_vm.itemCategoryTypes.RR)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.RR)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.rrTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.rrTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.rrTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.rrTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.RWA)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.RWA)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.rwaTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.rwaTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.rwaTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.rwaTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.REP)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.REP)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.repairTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.repairTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.repairTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.repairTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.PAINT)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(
                                    _vm.itemCategoryTypes.PAINT
                                  )
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.paintTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.paintTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.paintTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.paintTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.FIBER)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(
                                    _vm.itemCategoryTypes.FIBER
                                  )
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.fgTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.fgTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.fgTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.fgTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.CRUSH)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(
                                    _vm.itemCategoryTypes.CRUSH
                                  )
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.crushTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.crushTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.crushTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.crushTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.CD)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.CD)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.cdTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.cdTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.cdTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.cdTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.MECH)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.MECH)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.mechTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.mechTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.mechTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.mechTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.PART)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.PART)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.partTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.partTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.partTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.partTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.OPG)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.OPG)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.opgTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.opgTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.opgTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.opgTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.MISC)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.MISC)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.miscTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.miscTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.miscTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.miscTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isEnabled(_vm.itemCategoryTypes.SUBL)
                      ? _c(
                          "tr",
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDisplayName(_vm.itemCategoryTypes.SUBL)
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.value.sublTotal,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm.showSupplementaryQuoteTotals
                              ? [
                                  _vm._l(
                                    _vm.supplementaryQuotes,
                                    function (supp) {
                                      return _c(
                                        "td",
                                        {
                                          key: supp.quoteId,
                                          staticClass: "has-text-right",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$filters.formatNumber(
                                                  supp.sublTotal,
                                                  _vm.$userInfo.locale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          _vm.calculateGrandTotal(
                                            _vm.value.sublTotal,
                                            _vm.supplementaryQuotes.map(
                                              (q) => q.sublTotal
                                            )
                                          ),
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm.displayRemarks.length > 0
          ? _c("div", [
              _vm.hasPinnedRemarks
                ? _c("label", { staticClass: "label" }, [
                    _vm._v("Pinned Remarks"),
                  ])
                : _vm._e(),
              !_vm.hasPinnedRemarks
                ? _c("label", { staticClass: "label" }, [
                    _vm._v("Recent Remarks"),
                  ])
                : _vm._e(),
              _vm.value.subQuoteNos.length === 1 ||
              _vm.showSupplementaryQuoteTotals ||
              _vm.value.subQuoteNo > 0
                ? _c(
                    "table",
                    {
                      staticClass:
                        "table is-bordered is-striped is-narrow is-fullwidth",
                    },
                    [
                      _c("thead"),
                      _c(
                        "tbody",
                        _vm._l(_vm.displayRemarks, function (remark) {
                          return _c("tr", { key: remark.remarkId }, [
                            _c("td", { staticClass: "is-content-width" }, [
                              _c("span", { staticClass: "tag is-info" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      remark.remarkDateTime,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c("td", { staticClass: "is-remark" }, [
                              _c("div", [_vm._v(_vm._s(remark.remarks))]),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("Owner Cont. "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", [
      _vm._v("Total Payable "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }